const path = document.location.pathname;
const cardPathMatch = path.match(/tarot\/cards\/.*\/(.*)$/);

export const dropdowns = [
    {
        regex: /^\/astrology\/weekly-love-horoscopes(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: 'Monthly Horoscope',
                url: '/monthly-horoscope',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Love Readings & Reports',
                    url: '/readings-reports/love-readings',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-love-horoscope|astrology\/weekly-love-horoscopes)?(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Soulmate Tarot Reading',
                    url: '/readings-reports/tarot-readings/soulmate',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: 'Monthly Horoscope',
                url: '/monthly-horoscope',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Love Readings & Reports',
                    url: '/readings-reports/love-readings',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-horoscope|monthly-horoscope|astrology.*|cusps.*|articles.*|bios.*|tarot\/weekly-tarot-card-reading)?(\/.+)?$/i, //eslint-disable-line max-len
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: 'Weekly Tarot Horoscope',
                url: '/tarot/weekly-tarot-card-reading',
            },
            {
                label: 'Monthly Horoscope',
                url: '/monthly-horoscope',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
    {
        regex: /^\/tarot\/decks(\/)?$/,
        links: [
            {
                label: 'How to Choose a Tarot Deck',
                url: '#how-to-choose-a-tarot-deck',
            },
            {
                label: 'Best Tarot Decks for Beginners',
                url: '#best-tarot-decks-for-beginners',
            },
            {
                label: 'View Our Tarot Guide',
                url: '/tarot',
            },
            {
                label: 'Get a FREE Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: 'View All Tarot Readings',
                url: '/readings-reports/tarot',
            },
        ],
    },
    {
        regex: /^\/tarot\/cards(\/)?$/,
        links: [
            {
                label: 'What Are Tarot Cards?',
                url: '#what-are-tarot-cards',
            },
            {
                label: 'How Many Cards in a Tarot Deck?',
                url: '#how-many-cards-are-in-a-tarot-deck',
            },
            {
                label: 'How to Read Tarot Cards?',
                url: '#how-do-you-read-tarot-cards',
            },
            {
                label: 'How to Shuffle Tarot Cards?',
                url: '#how-do-you-shuffle-tarot-cards',
            },
            {
                label: 'Are Tarot Cards Evil?',
                url: '#are-tarot-cards-evil',
            },
        ],
    },
    {
        regex: /^\/tarot\/decks\/.*$/,
        links: [
            {
                label: 'Weekly Tarot Reading',
                url: '/tarot/weekly-tarot-card-reading',
            },
            {
                label: 'Get a FREE Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: 'View More Tarot Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'View All Tarot Readings',
                    url: '/readings-reports/tarot',
                },
            },
            {
                label: 'Yes or No Tarot Reading',
                url: '/readings-reports/tarot-readings/yes-no',
                logged_in: {
                    label: 'Set Your Favorite Tarot Deck',
                    url: '/member/settings/your-tarot-deck',
                },
            },
        ],
    },
    {
        regex: /^\/tarot\/cards\/.*$/,
        links: [
            {
                label: 'View All Cards in This Deck',
                url: `/tarot/decks/${cardPathMatch ? cardPathMatch[1] : 'universal-waite'}`,
            },
            {
                label: 'Get a FREE Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: 'View More Tarot Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'View All Tarot Readings',
                    url: '/readings-reports/tarot',
                },
            },
            {
                label: 'View Our Tarot Guide',
                url: '/tarot',
            },
        ],
    },
    {
        regex: /^(\/vip)?\/daily-tarot-card(\/.+)?$/i,
        links: [
            {
                label: 'Weekly Tarot Horoscope',
                url: '/vip/tarot/weekly-tarot-card-reading',
            },
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Yes or No Tarot Reading',
                url: '/readings-reports/tarot-readings/yes-no',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Tarot Readings & Reports',
                    url: '/readings-reports/tarot',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-hexagram|feng-shui.*)(\/.+)?$/i,
        links: [
            {
                label: 'I Ching Reading',
                url: '/readings-reports/i-ching/free',
            },
            {
                label: 'Love I Ching Reading',
                url: '/readings-reports/i-ching/free/love',
            },
            {
                label: 'Monthly Horoscope',
                url: '/monthly-horoscope',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/(daily-number|numerology.*)(\/.+)?$/i,
        links: [
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'View All Readings',
                    url: '/readings-reports',
                },
            },
            {
                label: 'Life Path Number Calculator',
                url: '/cosmic-profile',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Free Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Yes or No Tarot Reading',
                    url: '/readings-reports/tarot-readings/yes-no',
                },
            },
            {
                label: 'Free Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'More About Numerology',
                    url: '/numerology',
                },
            },
        ],
    },
    {
        regex: /^(\/vip)?\/daily-psychic-tip(\/.+)?$/i,
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Free 3-Card Love Tarot Reading',
                url: '/readings-reports/tarot-readings/free/love',
                logged_in: {
                    label: 'Soulmate Tarot Reading',
                    url: '/readings-reports/tarot-readings/soulmate',
                },
            },
            {
                label: 'Yes or No Tarot Reading',
                url: '/readings-reports/tarot-readings/yes-no',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
    {
        regex: /^\/horoscopes\/monthly\/(?:(?:jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)(\w+)?\-)?20[0-9]{2}(\/.+)?$/i, // eslint-disable-line no-useless-escape, max-len
        links: [
            {
                label: 'Free 3-Card Tarot Reading',
                url: '/readings-reports/tarot-readings/free',
                logged_in: {
                    label: 'Daily Reflection Tarot Reading',
                    url: '/readings-reports/tarot-readings/daily-reflection',
                },
            },
            {
                label: 'Weekly Love Horoscope',
                url: '/astrology/weekly-love-horoscopes',
            },
            {
                label: 'Weekly Tarot Horoscope',
                url: '/tarot/weekly-tarot-card-reading',
            },
            {
                label: 'Free Readings',
                url: '/readings-reports/free',
                logged_in: {
                    label: 'Readings & Reports',
                    url: '/readings-reports',
                },
            },
        ],
    },
].filter(({ regex }) => regex.test(path));

export const initial = dropdowns.length ? dropdowns[0].links : null;
